// import { AppStore } from '@bio/core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { Store, Select } from '@ngxs/store';
import {
  SetAuthToken,
  AsyncLogin,
  AppSessionState,
  IAppSession,
  AppGlobalConfigState,
  buildUrlLoginPunku,
  IServerConfig,
  IPunkuClaims,
} from '@lic/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-logging-in',
  templateUrl: './logging-in.component.html',
  styleUrls: ['./logging-in.component.scss'],
})
export class LoggingInComponent implements OnInit {
  @Select(AppSessionState.session) public session$: Observable<IAppSession>;
  @Select(AppSessionState.claims) public claims$: Observable<IPunkuClaims>;
  constructor(private route: ActivatedRoute, private appStore: Store, private router:Router) {}
  errorMessage:string=` No ha sido posible iniciar sesión. Por favor, vuelva a intentarlo en unos minutos.<br>
    Si el problema persiste ponte en contacto con el administrador del sistema`;

  ngOnInit() {
    //console.log('this.session$ :>> ', (this.session$.subscribe(x=>{console.log('x :>> ', x);})));
    this.claims$.subscribe(y=>{
      // console.log('y :>> ', y);
      if(y){
        if(y.HasErrors){
          this.errorMessage = y.Messages[0]+ `.<br>
          Si el problema persiste ponte en contacto con el administrador del sistema`;
        }
      }
    })
    const token: string = this.route.snapshot.queryParamMap.get('token');
    const returnUrl: string = this.route.snapshot.queryParamMap.get(
      'returnUrl'
    );
    // console.log('token :>> ', token);
    // console.log('returnUrl :>> ', returnUrl);
    
    if (token){
    //console.log('returnUrl :>> ', returnUrl); 
      this.appStore
        .dispatch(new SetAuthToken(token, returnUrl))
        .subscribe(() => {
          this.appStore.dispatch(new AsyncLogin());
        });
    }
  }

  handleRetryLogin = () => {
    //console.log('entro a handleRetryLogin ');
    const sessionStore = this.appStore.selectSnapshot<IAppSession>(
      (state) => state.appStore.session
    );
    const { punku } = this.appStore.selectSnapshot<IServerConfig>(
      (state) => state.appStore.globalConfig.configuration
    );
    window.location.href = buildUrlLoginPunku(punku, sessionStore.returnUrl);
  };
}
